import React from 'react';
import DivyadeepLogo from './DivyadeepLogo';

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] border-t border-white/5 py-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <DivyadeepLogo size="md" variant="light" />
            </div>
            <p className="text-sm text-white/40 font-manrope leading-relaxed">
              Best dermatologist in Jhansi. Expert skin care, hair transplant, pimple treatment, and hair fall treatment by Dr. Kuldeep Verma. IADVL certified skin clinic near Medical College Jhansi.
            </p>
          </div>

          {/* Treatments */}
          <div>
            <p className="font-outfit font-medium text-white text-sm mb-4">Treatments in Jhansi</p>
            <div className="space-y-2">
              {[
                { label: 'Hair Transplant in Jhansi', href: '#services' },
                { label: 'Pimple Treatment in Jhansi', href: '#services' },
                { label: 'Hair Fall Treatment', href: '#services' },
                { label: 'Laser Treatment', href: '#services' },
                { label: 'Skin Care Jhansi', href: '#services' },
                { label: 'Chemical Peeling', href: '#services' },
              ].map(link => (
                <a
                  key={link.label}
                  href={link.href}
                  className="block text-sm text-white/40 font-manrope hover:text-[#D1A760] transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="font-outfit font-medium text-white text-sm mb-4">Quick Links</p>
            <div className="space-y-2">
              {[
                { label: 'About Dr. Kuldeep Verma', href: '#about' },
                { label: 'Treatment Results', href: '#results' },
                { label: 'Patient Reviews', href: '#testimonials' },
                { label: 'Book Appointment', href: '#appointment' },
                { label: 'Contact Us', href: '#contact' },
              ].map(link => (
                <a
                  key={link.label}
                  href={link.href}
                  className="block text-sm text-white/40 font-manrope hover:text-[#D1A760] transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact NAP */}
          <div>
            <p className="font-outfit font-medium text-white text-sm mb-4">Skin Clinic in Jhansi</p>
            <div className="space-y-2 text-sm text-white/40 font-manrope" itemScope itemType="https://schema.org/LocalBusiness">
              <p itemProp="name" className="text-white/60 font-medium">Divyadeep Skin, Laser & Hair Transplant Center</p>
              <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                <p itemProp="streetAddress">Sunder Complex, Opp. Medical College</p>
                <p><span itemProp="addressLocality">Jhansi</span>, <span itemProp="addressRegion">Uttar Pradesh</span> <span itemProp="postalCode">284001</span></p>
              </div>
              <p className="text-[#D1A760]" itemProp="telephone">083033 65990</p>
              <p>Mon - Sat: 10:00 AM - 7:00 PM</p>

              {/* Social Links */}
              <div className="flex items-center gap-3 pt-3">
                <a
                  href="https://www.instagram.com/divyadeep_jhansi?igsh=MTZuNnUxOXV2cGo0YQ%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-white/[0.06] border border-white/10 flex items-center justify-center hover:bg-[#E1306C]/20 hover:border-[#E1306C]/40 transition-all duration-300"
                  data-testid="footer-instagram"
                  aria-label="Instagram"
                >
                  <svg className="w-4 h-4 text-white/60 hover:text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                </a>
                <a
                  href="https://www.facebook.com/share/1HEsMDvK16/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-white/[0.06] border border-white/10 flex items-center justify-center hover:bg-[#1877F2]/20 hover:border-[#1877F2]/40 transition-all duration-300"
                  data-testid="footer-facebook"
                  aria-label="Facebook"
                >
                  <svg className="w-4 h-4 text-white/60 hover:text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </a>
                <a
                  href="https://g.page/r/CVeIH6aZqTIREBM/review"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-white/[0.06] border border-white/10 flex items-center justify-center hover:bg-[#4285F4]/20 hover:border-[#4285F4]/40 transition-all duration-300"
                  data-testid="footer-google"
                  aria-label="Google Reviews"
                >
                  <svg className="w-4 h-4 text-white/60 hover:text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
                </a>
              </div>

              {/* Review on Google button */}
              <a
                href="https://g.page/r/CVeIH6aZqTIREBM/review"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-3 px-4 py-2 rounded-full bg-white/[0.08] border border-white/10 hover:bg-white/15 hover:border-[#D1A760]/40 transition-all duration-300 group"
                data-testid="footer-review-google-btn"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
                <span className="text-xs font-manrope font-medium text-white/70 group-hover:text-[#D1A760] transition-colors">Review us on Google</span>
              </a>
            </div>
          </div>
        </div>

        {/* SEO keyword footer bar */}
        <div className="mt-8 pt-6 border-t border-white/5">
          <p className="text-xs text-white/20 font-manrope text-center leading-relaxed mb-4">
            Dermatologist in Jhansi | Hair Transplant in Jhansi | Pimple Treatment in Jhansi | Hair Fall Treatment Jhansi | Best Hair Transplant Clinic Jhansi | Skin Clinic Near Me Jhansi | Skin Doctor Near Medical College Jhansi | Skin Care Jhansi | Best Doctor Jhansi
          </p>
          <p className="text-xs text-white/30 font-manrope text-center">
            &copy; {new Date().getFullYear()} Divyadeep Skin, Laser and Hair Transplant Center. All rights reserved. Best Dermatologist in Jhansi — Dr. Kuldeep Verma.
          </p>
          <div className="flex justify-center mt-4">
            <a
              href="https://medoratek.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="medoratek-pill relative inline-flex items-center gap-1.5 px-5 py-2 rounded-full bg-[#0F172A]"
              data-testid="footer-medoratek"
            >
              <span className="relative text-[11px] font-manrope text-white/40">Designed by</span>
              <span className="relative text-[11px] font-manrope font-semibold tracking-wide" style={{ color: '#10b884', textShadow: '0 0 12px rgba(16,184,132,0.6), 0 0 4px rgba(16,184,132,0.3)' }}>Medoratek</span>
            </a>
          </div>

          <style>{`
            .medoratek-pill {
              --angle: 0deg;
              border: 1.5px solid transparent;
              background-origin: border-box;
              background-clip: padding-box, border-box;
              background-image:
                linear-gradient(#0F172A, #0F172A),
                conic-gradient(from var(--angle), transparent 25%, #10b884 50%, transparent 75%);
              animation: medoratekSpin 3s linear infinite;
            }
            .medoratek-pill:hover {
              box-shadow: 0 0 24px rgba(16,184,132,0.25), 0 0 8px rgba(16,184,132,0.15);
            }
            @keyframes medoratekSpin {
              to { --angle: 360deg; }
            }
            @property --angle {
              syntax: '<angle>';
              initial-value: 0deg;
              inherits: false;
            }
          `}</style>
        </div>
      </div>
    </footer>
  );
}
